module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource.c99a2931.jpg";